import { render, staticRenderFns } from "./CreateOrderView.vue?vue&type=template&id=2886cf0e&"
import script from "./CreateOrderView.vue?vue&type=script&lang=js&"
export * from "./CreateOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports